import colors from "./colors";
import breakpoints from "./breakpoints";
import shadows from "./shadows";
import { typography, fonts } from "./typography";

export { colors, breakpoints, shadows, typography, fonts };

export const sizes = {
  profilePicWidth: "40vw",
  logo: "60px",
};
